// extracted by mini-css-extract-plugin
module.exports = {"control":"styles_control__2LX4a","inputField":"styles_inputField__1b9eg","sendBtnContainer":"styles_sendBtnContainer__1ajYG"};